import { computed, inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VideoFlowStateService } from '../video-flow-state.service';
import { VideoProductResponseService } from '../../../order-api-response/video-pd-response.service';
import { StreamHardwareSelectionData } from '../../../../../../../models/order/workflow/video/video-package-selection.model';



@Injectable({ providedIn: 'root' })
export class StreamHardwareSelectionStateService extends BaseWorkflowStateService<StreamHardwareSelectionData> {
    private flowStateService = inject(VideoFlowStateService);
    private videoPdResponseService = inject(VideoProductResponseService);
    override stateKey: string = 'streamhardwareSelection';

    customizations = computed(() => this.videoPdResponseService.getCustomizations());

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
